module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-quote-d0edf769.svg";